import * as vinTypes from './types';

export const showVindecode = (status, isDirect = false) => ({
  type: vinTypes.SHOW_VIN,
  payload: { status, isDirect },
});
export const hideVindecode = () => ({
  type: vinTypes.HIDE_VIN,
});

export const resetVehicle = () => ({
  type: vinTypes.RESET_VEHICLE,
});
export const showVehicle = (info) => ({
  type: vinTypes.SHOW_VEHICLE_INFO,
  payload: { info },
});
export const detectedOutline = (outlineData) => ({
  type: vinTypes.DETECT_OUTLINE_VEHICLE,
  payload: { outlineData },
});
export const setVinStatus = (status) => ({
  type: vinTypes.VIN_STATUS,
  payload: { status },
});
export const setIsManualCustom = (type) => ({
  type: vinTypes.VIN_MANUAL_CAM,
  payload: { type },
});

export const setQRScanner = (type) => ({
  type: vinTypes.VIN_QR_SCANNER,
  payload: { type },
});

export const resetOutline = (value) => ({
  type: vinTypes.RESET_OUTLINE,
  payload: { value },
});

export const setCages = (cages) => ({
  type: vinTypes.SET_CAGES,
  payload: { cages },
});
